/**
 * Symbolic name referring to the act of submitting an attempt to contact someone.
 */
export const CONTACT = 'CONTACT';
